<template>
  <v-container class="pa-5" fluid>
    <h1>{{ $t('watchlist') }}</h1>
    <v-spacer/>

    <h3 class="mt-3">{{ $t('watchlistAssociatedAssets',{watchlist: $t('watchlist')}) }}</h3>
    <v-row>
      <v-col lg="2" xl="2">
        <v-card class="adding-card-collapsed d-flex align-center justify-center" elevation="0" @click="showNewAssetWindow">
          <div class="d-flex justify-center">
            <v-icon class="plus-icon">fa-plus</v-icon>
            <h3 class="ml-2 mt-3" style="font-size: 17px">{{ $t('addAsset') }}</h3>
          </div>
        </v-card>
      </v-col>
      <SingleCardAd v-if="ad !== null && adIndex === 1" :ad="ad"/>
      <v-col v-for="asset in assets" v-bind:key="asset.ticker" cols="2">
        <v-card @mouseenter="hoverAsset = asset.id" @mouseleave="hoverAsset = -1" class="overall-card-collapsed" outlined>
          <v-card-title v-if="hoverAsset === asset.id" class="mt-n7 justify-end">
            <v-icon class="icon" color="secondary" @click="deleteAsset(asset)">fa-times-circle</v-icon>
          </v-card-title>
          <v-card-text :class="(hoverAsset !== asset.id)? 'pa-3 d-flex align-center' : 'mt-n7 pa-3 d-flex align-center'" style="height: 100%">
            <v-chip v-if="asset.market !== null" color="accent" class="mr-2" text-color="#6C7079" small>{{ asset.market.name }}</v-chip>
            <div>
              <h3 class="head">{{ truncateString(asset.ticker, 15) }}</h3>
              <p class="content">{{ truncateString(asset.assetName, 25) }}</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="this.$store.state.user.assets.length > 5" lg="2" xl="2">
        <v-card class="see-more-card-collapsed d-flex align-center justify-center" elevation="0" @click="overlaySeeAllAssets = true">
          <div class="d-flex justify-center">
            <h3 class="mr-2" style="font-size: 17px; text-decoration-line: underline;">{{ $t('seeXMore',{number: this.$store.state.user.assets.length - 4}) }}</h3>
            <v-icon small>fa-chevron-right</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-divider class="mt-5 mb-7"/>

    <h3 class="mt-3">{{ $t('watchlistStrategies',{watchlist: $t('watchlist')}) }}</h3>
    <v-row>
      <v-col lg="2" xl="2">
        <v-card class="adding-card-collapsed d-flex align-center justify-center" elevation="0" @click="showNewStrategyWindow">
          <div class="d-flex justify-center">
            <v-icon class="plus-icon">fa-plus</v-icon>
            <h3 class="ml-2 mt-3" style="font-size: 17px">{{ $t('addStrategy') }}</h3>
          </div>
        </v-card>
      </v-col>
      <SingleCardAd v-if="ad !== null && adIndex === 2" :ad="ad"/>
      <v-col v-for="strategy in strategies" v-bind:key="strategy.id" cols="2">
        <v-card @mouseenter="hoverStrategy = strategy.id" @mouseleave="hoverStrategy = -1" class="overall-card-collapsed" outlined>
          <v-card-title v-if="hoverStrategy === strategy.id" class="mt-n7 justify-end">
            <v-icon class="icon" color="secondary" @click="showDeleteStrategyWindow(strategy)">fa-times-circle</v-icon>
          </v-card-title>
          <v-card-text :class="(hoverStrategy !== strategy.id)? 'pa-3 d-flex align-center' : 'mt-n7 pa-3 d-flex align-center'" style="height: 100%">
            <div>
              <h3 class="head">{{ truncateString(strategy.name, 15) }}</h3>
              <p class="content">{{ truncateString(strategy.description, 25) }}</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="this.$store.state.user.strategies.length > 5" lg="2" xl="2">
        <v-card class="see-more-card-collapsed d-flex align-center justify-center" elevation="0" @click="overlaySeeAllStrategies = true">
          <div class="d-flex justify-center">
            <h3 class="mr-2" style="font-size: 17px; text-decoration-line: underline">{{ $t('seeXMore',{number: this.$store.state.user.strategies.length - 4 }) }}</h3>
            <v-icon small>fa-chevron-right</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-divider class="mt-5 mb-7"/>

    <h3 class="mt-3">{{ $t('watchlistHitsMistakes',{watchlist: $t('watchlist')}) }}</h3>
    <v-row>
      <v-col lg="2" xl="2">
        <v-card class="adding-card-collapsed d-flex align-center justify-center" elevation="0" @click="showNewConsiderationWindow">
          <div class="d-flex justify-center">
            <v-icon class="plus-icon">fa-plus</v-icon>
            <h3 class="ml-2 mt-3" style="font-size: 17px">{{ $t('addHitMistake') }}</h3>
          </div>
        </v-card>
      </v-col>
      <SingleCardAd v-if="ad !== null && adIndex === 3" :ad="ad"/>
      <v-col v-for="consideration in considerations" v-bind:key="consideration.id" cols="2">
        <v-card @mouseenter="hoverConsideration = consideration.id" @mouseleave="hoverConsideration = -1" class="overall-card-collapsed" outlined>
          <v-card-title v-if="hoverConsideration === consideration.id" class="mt-n7 justify-end">
            <v-icon class="icon" color="secondary" @click="deleteConsideration(consideration)">fa-times-circle</v-icon>
            <br>
          </v-card-title>
          <v-card-text :class="(hoverConsideration !== consideration.id)? 'pa-3 d-flex align-center' : 'mt-n7 pa-3 d-flex align-center'" style="height: 100%">
              <v-chip v-if="consideration.type !== null" :color="getConsiderationColor(consideration)" text-color="white" small>
                <v-icon class="mr-2" x-small>{{ getConsiderationIcon(consideration) }}</v-icon> {{ getConsiderationName(consideration) }}
              </v-chip>
              <h3 class="head ml-2" style="font-size: 20px">{{ truncateString(consideration.name, 15) }}</h3>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="this.$store.state.user.considerations.length > 5" lg="2" xl="2">
        <v-card class="see-more-card-collapsed d-flex align-center justify-center" elevation="0" @click="overlaySeeAllConsiderations = true">
          <div class="d-flex justify-center">
            <h3 class="mr-2" style="font-size: 17px; text-decoration-line: underline">{{ $t('seeXMore',{number: this.$store.state.user.considerations.length - 4  }) }}</h3>
            <v-icon small>fa-chevron-right</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-overlay :value="overlaySeeAllAssets">
      <SeeAllAssets @closeWindow="overlaySeeAllAssets = false" @removeAsset="deleteAsset"/>
    </v-overlay>
    <v-overlay :value="overlayAddAsset">
      <AddAsset @closeWindow="overlayAddAsset = false"/>
    </v-overlay>
    <v-overlay :value="overlayDeleteAsset">
      <DeleteAsset @closeDeleteWindow="overlayDeleteAsset = false" :asset="assetToBeDeleted"/>
    </v-overlay>
    <v-overlay :value="overlaySeeAllStrategies">
      <SeeAllStrategies @closeWindow="overlaySeeAllStrategies = false" @removeStrategy="showDeleteStrategyWindow"/>
    </v-overlay>
    <v-overlay :value="overlayNewStrategy">
      <AddStrategy @closeWindow="overlayNewStrategy = false"/>
    </v-overlay>
    <v-overlay :value="overlayDeleteStrategy">
      <DeleteStrategy :strategy="strategyToDelete" @closeDeleteWindow="overlayDeleteStrategy = false"/>
    </v-overlay>
    <v-overlay :value="overlaySeeAllConsiderations">
      <SeeAllConsiderations @closeWindow="overlaySeeAllConsiderations = false" @removeConsideration="deleteConsideration"/>
    </v-overlay>
    <v-overlay :value="overlayAddConsideration">
      <AddConsideration @closeWindow="overlayAddConsideration = false"/>
    </v-overlay>
    <v-overlay :value="overlayDeleteConsideration">
      <DeleteConsideration :consideration="considerationToBeDeleted" @closeWindow="overlayDeleteConsideration = false"/>
    </v-overlay>

    <!-- Overlay for Upgrade to Pro!-->
    <v-overlay v-model="dialogUpgradeToPro">
      <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="dialogUpgradeToPro = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import AdEngine from '../../ads/adEngine';

import AddStrategy from "./AddStrategy";
import {mapMutations} from 'vuex';
import DeleteStrategy from "./DeleteStrategy";
import ProLimits from '../../proLimits';
import UpgradeToPro from "../../components/UpgradeToPro";
import DeleteAsset from "@/views/Asset/DeleteAsset";
import AddAsset from "@/views/Asset/AddAsset";
import AddConsideration from "@/views/Consideration/components/AddConsideration";
import DeleteConsideration from "@/views/Consideration/components/DeleteConsideration";
import SeeAllAssets from "@/views/Asset/SeeAllAssets";
import SeeAllStrategies from "@/views/Watchlist/SeeAllStrategies";
import SeeAllConsiderations from "@/views/Consideration/components/SeeAllConsiderations";
import SingleCardAd from "@/ads/SingleCardAd";

export default {
  name: "Watchlist",
  components: {
    SingleCardAd,
    SeeAllConsiderations,
    SeeAllStrategies,
    SeeAllAssets,
    DeleteConsideration, AddConsideration, AddAsset, DeleteAsset, UpgradeToPro, DeleteStrategy, AddStrategy},
  data() {
    return {
      // Ads
      ad: null,
      adIndex: 0,

      hoverStrategy: -1,
      strategies: this.$store.state.user.strategies,
      overlaySeeAllStrategies: false,
      overlayNewStrategy: false,
      overlayDeleteStrategy: false,
      strategyToDelete: null,

      hoverAsset: -1,
      assets: this.$store.state.user.assets,
      overlaySeeAllAssets: false,
      overlayAddAsset: false,
      overlayDeleteAsset: false,
      assetToBeDeleted: null,

      hoverConsideration: -1,
      considerations: this.$store.state.user.considerations,
      overlaySeeAllConsiderations: false,
      overlayAddConsideration: false,
      overlayEditConsideration: false,
      overlayDeleteConsideration: false,
      considerationToBeDeleted: false,

      // Upgrade to pro
      messageUpgradeToPro: this.$t('messageUpgradeToPro'),
      dialogUpgradeToPro: false,
    };
  },
  watch: {
    '$store.state.user.assets': function () {
      this.init();
    },
    '$store.state.user.strategies': function () {
      this.init();
    },
    '$store.state.user.considerations': function () {
      this.init();
    },
  },
  computed: {
    nonNone(strategy) {
      return strategy !== 'None'
    },
  },
  mounted() {
    this.validateAuthenticated();
    this.init();
  },
  methods: {
    validateAuthenticated() {
      if (this.$store.state.token === '')
        this.$router.push('/');
    },
    retrieveAd() {
      this.ad = AdEngine.getRandomAd('Small Ad');
      this.adIndex = Math.floor(Math.random() * 3) + 1;
    },
    ...mapMutations(['setStrategies']),
    init() {
      this.retrieveAd();
      //if (this.$store.state.user.strategies.length === 0)
      //  this.overlayNewStrategy = true;
      this.assets = (this.$store.state.user.assets.length > 5 && this.adIndex === 1)? this.$store.state.user.assets.slice(0, 3) :
          this.$store.state.user.assets.length > 5? this.$store.state.user.assets.slice(0, 4) : this.$store.state.user.assets;

      this.strategies = (this.$store.state.user.strategies.length > 5 && this.adIndex === 2)? this.$store.state.user.strategies.slice(0, 3) :
          this.$store.state.user.strategies.length > 5? this.$store.state.user.strategies.slice(0, 4) : this.$store.state.user.strategies;

      this.considerations = (this.$store.state.user.considerations.length > 5 && this.adIndex === 3)? this.$store.state.user.considerations.slice(0, 3) :
          this.$store.state.user.considerations.length > 5? this.$store.state.user.considerations.slice(0, 4) : this.$store.state.user.considerations;
    },
    getConsiderationName(consideration) {
      let considerationType = consideration.type;
      return (considerationType === 'HIT')? this.$t('considerations.hit') : (considerationType === 'MISTAKE')? this.$t('considerations.mistake') : this.$t('considerations.other');
    },
    getConsiderationColor(consideration) {
      let considerationType = consideration.type;
      return (considerationType === 'HIT')? '#00a553' : (considerationType === 'MISTAKE')? '#f14400' : '#3b3b3b';
    },
    getConsiderationIcon(consideration) {
      let considerationType = consideration.type;
      return (considerationType === 'HIT')? 'fa-check' : (considerationType === 'MISTAKE')? 'fa-times' : 'fa-stop-circle';
    },
    strategyMonitor() {
      /*this.$router.push({
          name: 'strategy-overview',
          params: {asset: strategy},
      })*/
    },
    showNewAssetWindow() {
      if(this.$store.state.user.isPro || ProLimits.verifyLimitsByAssetsInWatchlist(this.$store.state.user.assets.length))
        this.overlayAddAsset = true;
      else
        this.dialogUpgradeToPro = true;
    },
    assetOverview(tickerSelected) {
      let foundAsset = this.assets.find((asset) => { return asset.ticker === tickerSelected });
      this.$router.push({
        name: 'asset-overview',
        params: {asset: foundAsset}
      });
    },
    deleteAsset(asset) {
      this.assetToBeDeleted = asset;
      this.overlayDeleteAsset = true;
    },
    showNewStrategyWindow() {
      if (this.$store.state.user.isPro || ProLimits.verifyLimitsByStrategies(this.$store.state.user.strategies.length))
        this.overlayNewStrategy = true;
      else
        this.dialogUpgradeToPro = true;
    },
    showDeleteStrategyWindow(strategy) {
      this.strategyToDelete = strategy;
      this.overlayDeleteStrategy = true;
    },
    showNewConsiderationWindow() {
      if (this.$store.state.user.isPro || ProLimits.verifyLimitsByConsiderations(this.$store.state.user.considerations.length))
        this.overlayAddConsideration = true;
      else
        this.overlayUpgradeToPro = true;
    },
    deleteConsideration(consideration) {
      this.considerationToBeDeleted = consideration;
      this.overlayDeleteConsideration = true;
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },
    truncateString(string, maxLength) {
      return (string !== null && string.length > maxLength) ? `${string.substring(0, maxLength)}...` : string;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../global";
</style>


<i18n>
{
  "en": {
    "watchlist": "Watchlist",
    "watchlistAssociatedAssets": "Your {watchlist} of associated assets",
    "addAsset": "Add Asset",
    "seeXMore": "See {number} more",
    "watchlistStrategies": "Your {watchlist} of technical/fundamental strategies (like setups or entry patterns)",
    "addStrategy": "Add Strategy",
    "watchlistHitsMistakes": "Your {watchlist} of hits and mistakes",
    "addHitMistake": "Add Hit/Mistake",
    "messageUpgradeToPro": "With pro you can create unlimited strategies/assets.",
    "considerations": {
      "hit": "Hit",
      "mistake": "Mistake",
      "other": "Other"
    }
  },
  "es":{
    "watchlist": "Lista de seguimiento",
    "watchlistAssociatedAssets": "Tu {watchlist} de activos",
    "addAsset": "Agregar Activo",
    "seeXMore": "Ver {number} más",
    "watchlistStrategies": "Tu {watchlist} de estrategias técnicas/fundamentales (por ejemplo, setups o patrones de entrada)",
    "addStrategy": "Agregar Estrategia",
    "watchlistHitsMistakes": "Tu {watchlist} de aciertos y errores",
    "addHitMistake": "Agregar Acierto/Error",
    "messageUpgradeToPro": "Ser pro te permite crear estrategias y activos ilimitados",
    "considerations": {
      "hit": "Acierto",
      "mistake": "Error",
      "other": "Otro"
    }
  }
}
</i18n>
